import { createEffect, ofType, Actions } from "@ngrx/effects";
import {
    withLatestFrom,
    switchMap,
    map,
    catchError, concatMap,
} from 'rxjs/operators';
import { Store } from "@ngrx/store";
import { DaveActions } from "../actions/actions";
import { HttpService } from "../../services/http.service";
import { State } from "../index";
import { CustomerSpecificationTypeActionTypes } from "../actions/customerSpecificationType.actions";
import {
    CustomerSpecificationTypeEntity,
    CustomerSpecificationTypeEntityFromBackend,
} from '../../entities/customerSpecificationType.entity';
import { BaseActionTypes } from "../actions/base.actions";
import { of } from "rxjs";
import { Injectable } from "@angular/core";
import { GraphQlEffectService } from '../../services/graph-ql-effect.service';
import { stringifyIfNotNullOrUndefined } from '../../../helper/helper';

enum ErrorCodes {
  Load = "Kundentypen Abrufen fehlgeschlagen",
  Modify = "Kundentypen Bearbeiten fehlgeschlagen",
    Change = 'Kundentypen Bearbeiten fehlgeschlagen',
    Remove = 'Kundentypen Löschen fehlgeschlagen',
    Add = 'Kundentypen Hinzufügen fehlgeschlagen'
}

@Injectable()
export class CustomerSpecificationTypeEffects {

    RemoveCustomerSpecificationType$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerSpecificationTypeActionTypes.Delete),
            concatMap(({ Payload }) => {
                const queryString = `
      mutation{
        deleteCustomerSpecificationType(id: ${Payload.id}){${CustomerSpecificationTypeEntity.GqlFields.join(',')}}
      }`;
                return this.gatewayHttpService.graphQl({ query: queryString }).pipe(
                    map(() =>
                        CustomerSpecificationTypeActionTypes.DeleteSuccess({
                            Payload: Payload.id,
                        })
                    ),
                    catchError((err, caught) =>
                        of(
                            BaseActionTypes.ErrorAction({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Remove,
                                    Err: err,
                                    Caught: caught,
                                },
                            }),
                        ),
                    ),
                );
            }),
        ),
    );

    CreateCustomerSpecificationType$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerSpecificationTypeActionTypes.Add),
            withLatestFrom(this.store$),
            concatMap(([{ Payload }, store]) => {
                const queryString = ` mutation{
        createCustomerSpecificationType(
         ${stringifyIfNotNullOrUndefined(Payload, 'name')}
        ){${CustomerSpecificationTypeEntity.GqlFields.join(', ')}}
      }`;
                return this.gatewayHttpService.graphQl({ query: queryString }, { token: store.base.token }).pipe(
                    map((res) => {
                        return res && res.createCustomerSpecificationType && res.createCustomerSpecificationType.id
                            ? CustomerSpecificationTypeActionTypes.AddSuccess({
                                Payload: CustomerSpecificationTypeEntityFromBackend(res.createCustomerSpecificationType),
                            })
                            : CustomerSpecificationTypeActionTypes.AddFailure({
                                Payload: {
                                    Errors: 'wrong response',
                                    ToasterMessage: ErrorCodes.Add,
                                },
                            });
                    }),
                    catchError((err, caught) =>
                        of(
                            CustomerSpecificationTypeActionTypes.AddFailure({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Add,
                                    Errors: err,
                                },
                            }),
                        ),
                    ),
                );
            }),
        ),
    );

    ModifyCustomerSpecificationType$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerSpecificationTypeActionTypes.ChangeCustomerSpecificationType),
            withLatestFrom(this.store$),
            concatMap(([{ Payload }, store]) => {
                const queryString = `
            mutation {
                changeCustomerSpecificationType(
                    id: ${Payload.id}
                  ${stringifyIfNotNullOrUndefined(Payload, 'name')}
                ) {
                   ${CustomerSpecificationTypeEntity.GqlFields.join(', ')}
                }
            }`;

                return this.gatewayHttpService.graphQl({ query: queryString }).pipe(
                    map((res) => {
                        return res && res.changeCustomerSpecificationType && res.changeCustomerSpecificationType.id
                            ? CustomerSpecificationTypeActionTypes.ChangeSuccess({
                                Payload: CustomerSpecificationTypeEntityFromBackend(res.changeCustomerSpecificationType),
                            })
                            : CustomerSpecificationTypeActionTypes.ChangeFailure({
                                Payload: {
                                    Errors: 'wrong response',
                                    ToasterMessage: ErrorCodes.Change,
                                },
                            });
                    }),
                    catchError((err, caught) =>
                        of(
                            CustomerSpecificationTypeActionTypes.ChangeFailure({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Add,
                                    Errors: err,
                                },
                            }),
                        ),
                    ),
                );
            }),
        ),
    );

  LoadCustomerSpecificationTypes = createEffect(() => this.actions$.pipe(
    ofType(CustomerSpecificationTypeActionTypes.GetCustomerSpecificationTypeRequest),
    withLatestFrom(this.store$),
    switchMap(([action, store]) => {
      const queryString = `
      query{
        customerspecificationtype{
          id
          name
          partnerId
        }
      }`;
      return this.gatewayHttpService
        .graphQl({ query: queryString }, { token: store.base.token, retry: true })
        .pipe(
          map(res =>
            res && res.customerspecificationtype
              ? CustomerSpecificationTypeActionTypes.UpdateCustomerSpecificationType({
                  Payload: res.customerspecificationtype.map(val =>
                    CustomerSpecificationTypeEntityFromBackend(val)
                  )
                })
              : BaseActionTypes.ErrorAction({
                  Payload: { ToasterMessage: ErrorCodes.Load }
                })
          ),
          catchError((err, caught) =>
            of(
              BaseActionTypes.ErrorAction({
                Payload: {
                  ToasterMessage: ErrorCodes.Load,
                  Err: err,
                  Caught: caught
                }
              })
            )
          )
        );
    })
  ));
    constructor(private actions$: Actions, private store$: Store<State>, private gatewayHttpService: HttpService, private graphQlEffectService: GraphQlEffectService) {}
}
